export default ({  
  fetching: {
    importLocusprimePatient: false
  },
  importLocusprimePatientsToken: '',
  importingLocusprimePatients: false,
  api: {}
});